import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, IconButton, Tooltip } from '@mui/material';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, GetSiteDropdowns, UpdateSites
} from '../../../actions/SiteTrackerActions.js';
import './SiteTrackerUpdate.css';
import SiteTrackerUpdateForm from './components/SiteTrackerUpdateForm';

const SiteTrackerUpdateDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.siteTrackerReducer.formState);
	const dropdowns = useSelector(state => state.siteTrackerReducer.dropdowns);

	return (
		<ModalDialog
			maxWidth="lg"
			onClose={onClose}
			open={open}
			title="Update"
			// confirmLabel="Ok"
			hasConfirm={false}
			cancelLabel="Close"
		>
			<SiteTrackerUpdateForm/>
		</ModalDialog>
	);
};

SiteTrackerUpdateDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default SiteTrackerUpdateDialog;
